.ux-iws-autosuggest {
    display: block;
    position: relative;
    width: 100%;
    background-color: $color-white;

    &__inner {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        padding: 25px;
        border: 1px solid $color-gray-borders;
        background-color: $color-white;
    }

    &__layout {
        display: flex;
        flex-flow: column wrap;
        gap: 30px;

        @media (min-width: $tablet) {
            flex-flow: row nowrap;
        }
    }

    &__suggestions {
        flex-grow: 1;
    }

    &__extras {
        min-width: 30%;
    }

    &__extras__list {
        list-style: none;
        margin: 0;
        padding: 0;
        margin-left: -25px;
        margin-right: -25px;
    }

    &__quick-links {
        padding-bottom: 20px;
    }

    &__results {
        margin-left: -25px;
        margin-right: -25px;
    }

    &__title {
        text-transform: uppercase;
        width: 100%;
        border-bottom: 1px solid $color-black-4;
        margin-bottom: 15px;
        margin-top: 0;
        font-family: "Frutiger-Bold", sans-serif;
        color: $color-black-1;
        font-size: 13px;
        padding-bottom: 5px;
    }

    &__button {
        display: inline-block;
        width: 100%;
        text-align: left;
        background-color: transparent;
        border: 0;
        padding: 12px 25px;
        cursor: pointer;
        font-family: "Frutiger-Bold", sans-serif;
        color: $color-black-1;
        text-decoration: none;
        line-height: 1.15;

        span {
            font-family: "Frutiger-Light", sans-serif;
            color: $color-scroll-bar;
        }

        &:hover,
        &:focus {
            background-color: $color-blue-6;
        }
    }
}
